export const pickerDict = {
    'Цвет баннеров': 'цвет для баннеров',
    'Освещение 1': 'первое освещение',
    'Освещение 2': 'второе освещение',
    'Телевизор 1': 'первый телевизор',
    'Телевизор 2': 'второй телевизор',
    'Мебель 1': 'первую мебель',
    'Мебель 2': 'вторую мебель',
    'Стойка ресепшн': 'стойку ресепшна',

    'Внутренняя зона №1': 'Выберите наполнение внутренней зоны №1',
    'Внутренняя зона №2': 'Выберите наполнение внутренней зоны №2',
    'Внутренняя зона': 'Выберите наполнение внутренней зоны',
    'Выставочный объект': 'Примеры выставочных объектов',
};
